import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box, CircularProgress } from '@mui/material'
import { IStore } from '../../store/types'
import { CurrentDialog } from '../../components/SearchWorkspace/CurrentDialog'
import { useAppDispatch } from '../../store'
import { getDialog, getDialogMessages } from '../../store/searchChatsUnauthorized/actions'
import { SearchChatsUnauthorizedActions } from '../../store/searchChatsUnauthorized'
import { InnerHeight, SIZE_PROG } from '../../utils/consts'
import { ChatHeaderInfo } from '../../components/ChatHeaderInfo'
import { ROUTES } from '../../utils/routes'

export const CurrentDialogUnauthorized: React.FC = () => {
  const { searchChatsUnauthorized, configurations } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { id } = useParams()

  React.useEffect(() => {
    if (id) {
      dispatch(getDialog(Number(id)))
    }
  }, [])

  const handleGetDialogMessages = (data: { id: number; page: number }, callback?: () => void) => {
    dispatch(getDialogMessages(data)).then(callback)
  }

  const handleCloseDialog = () => {
    dispatch(SearchChatsUnauthorizedActions.setDialog(null))
    navigate(ROUTES.changeSearch(''))
  }

  if (!searchChatsUnauthorized.dialog) {
    return (
      <Box display={'flex'} height={'100%'} alignItems={'center'} justifyContent={'center'}>
        <CircularProgress size={SIZE_PROG} />
      </Box>
    )
  }

  return (
    <Box px={3} height={InnerHeight} overflow={'auto'} display={'flex'} flexDirection={'column'}>
      {searchChatsUnauthorized.dialog ? (
        <ChatHeaderInfo
          siteUrl={configurations.all?.find((item) => item.absnum === searchChatsUnauthorized.dialog?.site_id)?.url}
          currentChat={{
            ...searchChatsUnauthorized.dialog,
            profile: {
              fio: searchChatsUnauthorized.dialog.client_fio,
              email: searchChatsUnauthorized.dialog.email,
              phone: searchChatsUnauthorized.dialog.phone,
            },
          }}
          comeBack={handleCloseDialog}
        />
      ) : null}
      <CurrentDialog dialog={searchChatsUnauthorized.dialog} getDialogMessages={handleGetDialogMessages} />
    </Box>
  )
}
